import { node, oneOf } from 'prop-types';
import React from 'react';

function Tooltip(props) {
  const { children, location } = props;
  return (
    <div className={`Tooltip Tooltip--${location}`}>
      {children}
      <style jsx>{`
        .Tooltip {
          position: absolute;
          top: 0;
          padding: 1rem;
          background-color: #fff;
          font-size: 12.64198px;
          line-height: 1.4;
          filter: drop-shadow(2px 2px 6px #999);
          z-index: 5000;
        }

        .Tooltip::after {
          position: absolute;
          content: '';
          display: block;
          width: 0;
          height: 0;
        }

        .Tooltip--bottom {
          margin-top: 1rem;
        }

        .Tooltip--bottom::after {
          top: -1rem;
          left: 50%;
          transform: translateX(-50%);
          border-bottom: 16px solid #fff;
          border-right: 10px solid transparent;
          border-left: 10px solid transparent;
        }

        .Tooltip--left {
          margin-right: 1rem;
        }

        .Tooltip--left::after {
          right: -1rem;
          top: 50%;
          transform: translateY(-50%);
          border-left: 16px solid #fff;
          border-top: 10px solid transparent;
          border-bottom: 10px solid transparent;
        }

        .Tooltip--right {
          margin-left: 1rem;
        }

        .Tooltip--right::after {
          left: -1rem;
          top: 50%;
          transform: translateY(-50%);
          border-right: 16px solid #fff;
          border-top: 10px solid transparent;
          border-bottom: 10px solid transparent;
        }

        .Tooltip--top {
          margin-bottom: 1rem;
        }

        .Tooltip--top::after {
          bottom: -1rem;
          left: 50%;
          transform: translateX(-50%);
          border-top: 16px solid #fff;
          border-right: 10px solid transparent;
          border-left: 10px solid transparent;
        }
      `}</style>
    </div>
  );
}

Tooltip.propTypes = {
  children: node.isRequired,
  location: oneOf(['top', 'right', 'bottom', 'left'])
};

Tooltip.defaultProps = {
  location: 'top'
};

export default Tooltip;
